import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { NonTypeTab, TemplateTab } from '../types/TemplateTabs';

export enum SideBarItemType {
  HEADING = 'heading',
  TEMPLATE_TAB = 'template-tab',
}

export interface ISideBarItem {
  id: TemplateTab | string;
  type: SideBarItemType;
  sideBarItemKey: string;
  gridTitleKey?: string;
  gridSubtitleKey?: string;
  gridDocsKey?: string;
  badgeTextKey?: string;
}

export const SIDEBAR_ITEMS: ISideBarItem[] = [
  {
    id: NonTypeTab.ALL,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.tabs.all',
    gridTitleKey: 'app.grid.title.all-templates',
    gridSubtitleKey: 'app.grid.subtitle.all-templates.no-links',
    gridDocsKey: 'app.grid.subtitle.all-templates.external-doc-link',
  },
  {
    id: 'developer-tools',
    type: SideBarItemType.HEADING,
    sideBarItemKey: 'app.sidebar.developer-tools',
  },
  {
    id: DevelopmentTool.BLOCKS,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.wix-blocks',
    gridTitleKey: 'app.grid.title.blocks',
    gridSubtitleKey: 'app.grid.subtitle.blocks',
    gridDocsKey: 'app.grid.docs.blocks',
    badgeTextKey: 'app.badge.wix-blocks',
  },
  {
    id: DevelopmentTool.CLI,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.wix-cli',
    gridTitleKey: 'app.grid.title.cli',
    gridSubtitleKey: 'app.grid.subtitle.cli',
    gridDocsKey: 'app.grid.docs.cli',
    badgeTextKey: 'app.badge.wix-cli',
  },
  {
    id: DevelopmentTool.DEV_CENTER,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.dev-center',
    gridTitleKey: 'app.grid.title.dev-center',
    gridSubtitleKey: 'app.grid.subtitle.dev-center',
    gridDocsKey: 'app.grid.docs.dev-center',
    badgeTextKey: 'app.badge.dev-center',
  },
];
